<template>
  <div class="posterActivitiesManage">
    <PageNav>
      <el-main>
        <div id="page-posterActivitiesManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">{{
                $t("Crmactivemanage.pageTitle")
              }}</span>
              <div class="pull-right">
                <el-button
                  v-if="postbe_crmlevel == '1' || postbe_crmlevel == 3"
                  @click="handAdd()"
                  type="warning"
                  >{{ $t("Crmactivemanage.ab") }}</el-button
                >
                <el-button type="primary" @click="daochu">{{
                  $t("Common.btn_export")
                }}</el-button>
              </div>
            </div>
          </div>
          <div class="posterActivitiesManage-container">
            <div class="content">
              <div class="flex-wrap">
                <div class="flex-al mb20 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Crmactivemanage.ac")
                  }}</span>
                  <div class="time-box flex-al">
                    <el-date-picker
                      v-model="selectForm.range_time"
                      type="daterange"
                      style="width:260px;"
                      :range-separator="$t('Common.to')"
                      value-format="yyyy-MM-dd"
                      :start-placeholder="$t('Common.startTime')"
                      :end-placeholder="$t('Common.endTime')"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb20 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Crmactivemanage.label_text1")
                  }}</span>
                  <div class="select-box" style="width:120px;">
                    <el-select
                      filterable
                      v-model="selectForm.found_marketer_id"
                      class="mr15"
                      style="width: 120px;"
                      clearable
                      :placeholder="$t('Crmactivemanage.placeholder2')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in founder"
                        :key="item.marketer_id"
                        :label="
                          `${item.marketer_name} ${
                            item.staffer_enname
                              ? '(' + item.staffer_enname + ')'
                              : ''
                          }`
                        "
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb20 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Crmactivemanage.an")
                  }}</span>
                  <div class="select-box" style="width:120px;">
                    <el-select
                      @change="frommediaSearch"
                      v-model="selectForm.frommedia_name"
                      clearable
                      filterable
                      :placeholder="$t('Crmactivemanage.ao')"
                    >
                      <el-option
                        :label="$t('Crmactivemanage.ak')"
                        value
                      ></el-option>
                      <el-option
                        v-for="item in SourceList"
                        :key="item.frommedia_id"
                        :label="item.frommedia_name"
                        :value="item.frommedia_name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb20 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Crmactivemanage.ap")
                  }}</span>
                  <div class="select-box" style="width:120px;">
                    <el-select
                      @change="handleSelect()"
                      v-model="selectForm.channel_id"
                      clearable
                      filterable
                      :placeholder="$t('Crmactivemanage.aq')"
                    >
                      <el-option
                        :label="$t('Crmactivemanage.ak')"
                        value
                      ></el-option>
                      <el-option
                        v-for="item in ChannelList"
                        :key="item.channel_id"
                        :label="item.channel_name"
                        :value="item.channel_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al Inquire-box mb20">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      :placeholder="$t('Crmactivemanage.placeholder1')"
                      class="input-cont"
                      style="width:200px"
                      v-model="selectForm.keyword"
                      @change="handleSelectKeyword()"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelectKeyword()"
                    >{{ $t("Crmactivemanage.as") }}</el-button
                  >
                </div>
              </div>
              <div class="tableList" ref="auto_height_table">
                <imgTableCont
                  :tableData="tableList"
                  @handleColumnChange="handleColumnChange"
                  @handleCodeChange="handleCodeChange"
                >
                  <!-- 按钮操作组********start -->
                  <el-table-column
                    ref="fixedColumn"
                    label="操作"
                    align="center"
                    width="200px"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click.native.prevent="handSee(scope.row)"
                        >{{ $t("Crmactivemanage.btn_see") }}</el-button
                      >
                      <el-button
                        type="text"
                        size="small"
                        v-if="companyIsmajor == '2' && postbe_crmlevel == '1'"
                        @click.native.prevent="handCopy(scope.row)"
                        >{{ $t("Crmactivemanage.btn_copy") }}</el-button
                      >
                      <el-button
                        type="text"
                        size="small"
                        v-if="
                          (postbe_crmlevel == '1' ||
                            (postbe_crmlevel == 3 &&
                              scope.row.marketer_id == marketer_id)) &&
                            scope.row.activity_type != '1'
                        "
                        @click.native.prevent="handDel(scope.row)"
                        >{{ $t("Crmactivemanage.btn_del") }}</el-button
                      >
                    </template>
                  </el-table-column>
                  <!-- 按钮操作组********end -->
                </imgTableCont>
              </div>
              <!-- 分页 -->
              <el-pagination
                style="margin-top: 10px;"
                :current-page.sync="paging.curPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size.sync="paging.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="paging.pageTotal"
                @current-change="curPageChange"
                @size-change="pageSizeChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <!-- 二维码 -->
    <el-dialog
      :visible.sync="dialogVisible"
      class="tan-code clearFloat"
      width="500px"
      :before-close="handleCloseCode"
    >
      <div
        class="pull-right h1 btn-close font-333"
        style="cursor:pointer"
        @click="handleCloseCode"
      >
        <i class="el-icon-close"></i>
      </div>
      <div class="code">
        <div class="code-img">
          <div class="left">
            <!-- <p v-if="languageType=='zh'">{{$t("Crmactivemanage.at")}}</p> -->
            <div
              class="one-img"
              :class="{ 'one-tw-img': languageType != 'zh' }"
            >
              <img :src="onCodeInfo.oneCodeImg" alt />
            </div>
          </div>
          <!-- <div v-if="languageType=='zh'" class="right">
            <p>{{$t("Crmactivemanage.au")}}</p>
            <iframe frameborder="0" :src="onCodeInfo.oneCodeWxImg" width="220" height="220"></iframe>
          </div> -->
        </div>

        <p class="h1">{{ $t("Crmactivemanage.av") }}</p>
      </div>
      <p style="text-align:center;word-break: break-all;">
        {{ $t("Crmactivemanage.aw") }}{{ onCodeInfo.oneCodeUrl }}
      </p>
    </el-dialog>

    <!-- 侧边新建栏 -->
    <SliderBox
      :showSliderBox="showSliderBoxCreate"
      @hideSliderBox="showSliderBoxCreate = false"
      :sliderWidth="sliderWidth"
    >
      <posterActiveTeamp
        :aciveInfo="aciveCreateInfo"
        :showSliderBox="showSliderBoxCreate"
        @hideSliderBox="showSliderBoxCreate = false"
        @onSubmit="onSubmit"
        @perviewTemp="perviewTemp"
        @perviewSeeTemp="perviewSeeTemp"
      ></posterActiveTeamp>
    </SliderBox>
    <!-- 编辑 -->
    <SliderBox
      :showSliderBox="showSliderBoxEdit"
      @hideSliderBox="showSliderBoxEdit = false"
      :sliderWidth="sliderWidth"
    >
      <posterActiveTeamp
        :aciveInfo="aciveEditInfo"
        :showSliderBox="showSliderBoxEdit"
        :isEdit="true"
        :infomationData="infomationData"
        @hideSliderBox="showSliderBoxEdit = false"
        @onSubmit="onEditSubmit"
        @perviewTemp="perviewTempEdit"
        @perviewSeeTemp="perviewSeeTempEdit"
      ></posterActiveTeamp>
    </SliderBox>

    <!-- 侧边查看栏 -->
    <!-- 侧边栏 -->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderBoxSee"
      :sliderWidth="sliderSeeWidth"
    >
      <div
        class="silder-contain slider-posterActivitiesManage silder-contain-seeing"
      >
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">
            {{ $t("Crmactivemanage.title3") }}
          </p>
          <div
            class="pull-right h1 btn-close font-gray"
            @click="hideSliderBoxSee"
          >
            <i class="el-icon-close"></i>
          </div>
          <el-button
            type="primary"
            v-if="
              (postbe_crmlevel == '1' ||
                (postbe_crmlevel == 3 &&
                  infomationData.marketer_id == marketer_id)) &&
                infomationData.activity_type != '1'
            "
            class="pull-right"
            @click="handEdit()"
            >{{ $t("Crmactivemanage.ay") }}</el-button
          >
        </div>
        <div class="slider-cont text-1">
          <div class="active-cont">
            <iframe
              :src="`${infomationData.activity_PersonalUrl}&open_type=crm`"
              name="test"
              width="375"
              height="750"
              frameborder="1"
              align="left"
              scrolling="yes"
            ></iframe>
          </div>
        </div>
      </div>
    </SliderBox>
    <!-- 活动模板预览图 -->
    <el-dialog
      :visible.sync="PreviewVisible"
      class="tan-Preview"
      width="30%"
      :before-close="handleClosePreview"
    >
      <div class="Preview-img">
        <img :src="ActivitytempOne.activitytemp_styleimg_url" />
      </div>
    </el-dialog>

    <!-- 删除 -->
    <el-dialog
      :title="$t('Crmactivemanage.az')"
      :visible.sync="DelVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Crmactivemanage.ba") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DelVisible = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="handleDelClickConfim()">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 复制 -->
    <el-dialog
      :title="$t('Crmactivemanage.dialog_title')"
      :visible.sync="copyItem"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Crmactivemanage.dialog_cont") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyItem = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="copyActivityOneApi()">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageNav from "../../components/Nav/nav.vue";
import SliderBox from "../../components/SliderBox";
import imgTableCont from "../../components/tables/imgTableCont.vue";
import posterActiveTeamp from "../../components/Activity/posterActive.vue";
import CrmActiveManage from "../Crmactivemanage/crmActiveManage.js";
export default {
  name: "posterActivitiesManage-posterActivitiesManage",
  data() {
    return {
      marketer_id: "",
      showSliderBoxCreate: false, //新增
      showSliderBoxEdit: false, //编辑
      showSliderBoxSee: false, //预览
      dialogVisible: false, //查看二维码
      PreviewVisible: false, //活动模板预览图
      DelVisible: false, //删除
      copyItem: false, //复制
      onCodeInfo: {
        oneCodeImg: "", //单个活动的二维码
        oneCodeWxImg: "", //单个活动的二维码---微信
        oneCodeUrl: "", //单个活动的url
      },
      ActivitytempOne: {}, //单个模板信息
      dialogimgVisible: false,
      sliderWidth: "700px",
      sliderSeeWidth: "450px",
      activityId: "", //暂存查看的活动id
      //筛选条件
      selectForm: {
        range_time: "",
        found_marketer_id: "",
        channel_id: "", //渠道明细
        frommedia_name: "", //渠道类型
        keyword: "",
      },
      //创建人
      founder: [],
      SourceList: [], //选择渠道类型-下拉数据
      ChannelList: [], //选择渠道明细-下拉数据
      // 发布活动
      aciveCreateInfo: {
        aciveText: this.$t("Crmactivemanage.title1"),
        aciveClass: "silder-contain-creat",
      },
      // 编辑活动
      aciveEditInfo: {
        aciveText: this.$t("Crmactivemanage.title2"),
        aciveClass: "silder-contain-edit",
      },
      // 活动详情
      infomationData: [],
      // 表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: 0,
          moduleName: "Crmactivemanage", //当前页面所属于模块的名称****一个模块是唯一的
          ColumnName: "posterActivitiesManage", //当前页面的名称，通常与路由名称一致
        },
      },
      // 分页
      paging: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  components: {
    PageNav,
    SliderBox,
    imgTableCont,
    posterActiveTeamp,
  },
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.languageType = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "zh";
    this.companyIsmajor = this.$store.state.companyIsmajor; //0是免费版 1是普通版   2是专业版
    this.getShareposterList();
    this.getActivityFounderData(); // 获取目标创建人管理
    this.getSourceApi(); // 获取渠道类型
    this.getChannelApi(); // 获取渠道明细
  },
  computed: {},
  methods: {
    // 海报活动->列表
    getShareposterList() {
      CrmActiveManage.getShareposterList({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        is_count: "1", //是否需要总数，可以不传
        p: this.paging.curPage,
        num: this.paging.pageSize,
        //筛选条件
        activity_starttime: this.selectForm.range_time
          ? this.selectForm.range_time[0]
          : "",
        activity_endtime: this.selectForm.range_time
          ? this.selectForm.range_time[1]
          : "",
        found_marketer_id: this.selectForm.found_marketer_id,
        frommedia_name: this.selectForm.frommedia_name,
        channel_id: this.selectForm.channel_id,
        keyword: this.selectForm.keyword,
      }).then((res) => {
        this.paging.pageTotal = parseInt(res.data.data.allnum);
        let obj = this.$Tool.getStorage(
          "module" + [this.tableList.options.moduleName]
        );
        if (obj) {
          if (obj["show_" + [this.tableList.options.ColumnName]]) {
            this.tableList.columns =
              obj["show_" + [this.tableList.options.ColumnName]];
          } else {
            this.tableList.columns = res.data.data.field;
          }
        } else {
          this.tableList.columns = res.data.data.field;
        }
        if (res.data.code === 200) {
          this.tableList.list = res.data.data.list;
        } else {
          this.tableList.list = [];
          this.tableList.options.errortip = res.data.msg;
        }
        (() => {})(this.tableList);
      });
    },
    // 获取渠道类型
    getSourceApi() {
      this.$http
        .getSourceApi({
          staffer_id: this.staffer_id,
          company_id: this.company_id,
          token: this.token,
        })
        .then((res) => {
          this.SourceList = res.data.data.list;
        });
    },
    // 获取渠道明细
    getChannelApi() {
      this.$http
        .getChannelApi({
          staffer_id: this.staffer_id,
          company_id: this.company_id,
          token: this.token,
          channel_medianame: this.selectForm.frommedia_name,
        })
        .then((res) => {
          this.ChannelList = res.data.data.list;
        });
    },
    // 获取目标创建人管理
    getActivityFounderData() {
      CrmActiveManage.getActivityFounder({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
      }).then((res) => {
        // 
        this.founder = res.data.data.data;
      });
    },
    //单个招生活动查看
    getgoalActivityOneData() {
      CrmActiveManage.getgoalActivityOne({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        activity_id: this.activityId, //活动 id
      }).then((res) => {
        
        this.infomationData = res.data.data.data;
        this.showSliderBoxSee = true;
      });
    },
    // 选择查询
    handleSelect() {
      this.paging.curPage = 1;
      this.getShareposterList();
    },
    // 招生渠道类型筛选
    frommediaSearch() {
      this.paging.curPage = 1;
      this.selectForm.channel_id = "";
      this.getChannelApi(); // 获取渠道明细
      this.getShareposterList();
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.paging.curPage = 1;
      this.getShareposterList();
    },
    // 点击发布活动
    handAdd() {
      this.showSliderBoxCreate = true;
    },
    // 点击预览
    handSee(v) {
      (() => {})(v);
      this.activityId = v.activity_id;
      this.getgoalActivityOneData();
    },
    // 点击编辑
    handEdit() {
      this.showSliderBoxSee = false;
      this.showSliderBoxEdit = true;
    },
    // 点击复制活动
    handCopy(v) {
      this.copyItem = true;
      this.activityId = v.activity_id;
    },
    // 复制活动---api
    copyActivityOneApi() {
      CrmActiveManage.copyActivityOneApi({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        activity_id: this.activityId,
      }).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.copyItem = false;
          this.getShareposterList();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 点击删除
    handDel(v) {
      this.DelVisible = true;
      this.activityId = v.activity_id;
    },
    // 点击名字查看单个活动
    handleColumnChange(k, v, column) {
      (() => {})(v, k);
      this.activityId = column.activity_id;
      this.getgoalActivityOneData();
    },
    //点击查看二维码
    handleCodeChange(k, v, col) {
      (() => {})(k, v, col);
      if (col.fieldname == "shareqrcode") {
        this.onCodeInfo.oneCodeImg = v.shareqrcode;
        this.onCodeInfo.oneCodeUrl = v.shareqrcodeurl;
      } else {
        this.onCodeInfo.oneCodeImg = v.personalshareqrcode;
        this.onCodeInfo.oneCodeUrl = v.personalshareqrcodeurl;
      }
      this.dialogVisible = true;
    },
    // 确定删除
    handleDelClickConfim() {
      // 删除招生活动
      CrmActiveManage.delGoalActivity({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        activity_id: this.activityId,
      }).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.showSliderBoxEdit = false;
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getShareposterList();
          this.DelVisible = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 预览模版******新建
    perviewTemp(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_styleimg;
      this.ActivitytempOne = v;
    },
    // 查看预览图******新建
    perviewSeeTemp(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_bannerimg;
      this.ActivitytempOne = v;
    },
    // 预览模版******编辑
    perviewTempEdit(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_styleimg;
      this.ActivitytempOne = v;
    },
    // 查看预览图******编辑
    perviewSeeTempEdit(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_bannerimg;
      this.ActivitytempOne = v;
    },
    // 关闭预览活动弹框
    hideSliderBoxSee() {
      this.showSliderBoxSee = false;
    },
    //发布招生活动
    onSubmit(v) {
      // 添加招生活动
      CrmActiveManage.addGoalActivity(v).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getShareposterList();
          this.showSliderBoxCreate = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //编辑招生活动提交
    onEditSubmit(v) {
      let data = v;
      data.activity_id = this.activityId;
      // 修改招生活动
      CrmActiveManage.updateGoalActivity(data).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.showSliderBoxCreate = false;
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getShareposterList();
          this.showSliderBoxEdit = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 页码变化
    curPageChange(v) {
      this.paging.curPage = v;
      this.getShareposterList();
    },
    // pageSize改变
    pageSizeChange(v) {
      (() => {})(v);
      this.paging.curPage = 1;
      this.getShareposterList();
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      this.selectForm.activity_starttime = this.selectForm.range_time
        ? this.selectForm.range_time[0]
        : "";
      this.selectForm.activity_endtime = this.selectForm.range_time
        ? this.selectForm.range_time[1]
        : "";
      // eslint-disable-next-line no-global-assign
      for (name in this.selectForm) {
        if (name != "rang_time") {
          // 时间范围不需要
          params_str = params_str + `&${name}=${this.selectForm[name]}`;
        }
      }
      let url = CrmActiveManage.getShareposterList1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableList.list.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
    // 关闭弹框
    handleClose(done) {
      this.$confirm(this.$t("Crmactivemanage.bo"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    // 关闭二维码弹框
    handleCloseCode() {
      this.dialogVisible = false;
    },
    // 关闭活动模板预览图
    handleClosePreview() {
      this.PreviewVisible = false;
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableList.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 70
        );
      }
    });
  },
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");
@import url("crmActiveManage.less");

.posterActivitiesManage {
  height: 100vh;
  font-size: 20px;
  .code-img {
    width: 100%;
    display: flex;
    justify-content: space-between;
    > div {
      flex: 1;
      img {
        width: 300px !important;
        // height: 165px;
      }
    }
    .left {
      margin-right: 10px;
      .one-img {
        // width: 220px;
        // height: 220px;
        width: 300px;
        padding-top: 13px;
        margin: 0 auto;
      }
      .one-tw-img {
        width: 300px;
        height: 300px;
        margin: 0 auto;

        img {
          width: 100% !important;
          height: 100%;
        }
      }
    }
    .right {
      margin-left: 10px;
    }
    iframe {
      * {
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }
}
</style>
